module.exports = __webpack_public_path__ + "img/glass.0a8f11d5.png";